/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Note_Filter_All_ReasonsInputs */

const vi_sl_note_filter_all_reasons = /** @type {(inputs: Sl_Note_Filter_All_ReasonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả lý do`)
};

/**

* @param {Sl_Note_Filter_All_ReasonsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_note_filter_all_reasons = /** @type {((inputs?: Sl_Note_Filter_All_ReasonsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Note_Filter_All_ReasonsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_note_filter_all_reasons(inputs)
});